import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import {
  Button,
  Collapse,
  Modal,
  Input,
  Select,
  Form,
  message,
  Checkbox,
  Table,
  Popconfirm,
  Radio,
  notification,
} from "antd";
import {
  alterUserStatus,
  createUser,
  editUser,
  getUsersList,
  loginAsUser,
  pageAccess,
} from "../../../API/Company/user";
import {
  getUserVehicleAccess,
  grantVehicleAccess,
  revokeVehicleAccess,
  getCompanyVehicles,
} from "../../../API/Company/vehicles";
import { ClipLoader } from "react-spinners";
import { UserContext } from "../../../App";
import { encryptText } from "../../../Utils/Encryption";
import updateUserStates from "../../../Utils/UpdateUsersState";
import { useNavigate } from "react-router-dom";
import { deleteUser } from "../../../API/Admin/user";
import {
  CaretDownOutlined,
  CaretUpOutlined,
  DeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { checkApiKeyValidity } from "../../../API/auth";
import { getAdminPages } from "../../../API/User/user";

const { Panel } = Collapse;
const { Option } = Select;

const SELECT_ALL_VALUE = "__SELECT_ALL__";

const Users = ({ setFlag }) => {
  const [users, setUsers] = useState([]);
  const {
    userData,
    setUserPages,
    setUserToken,
    setUserData,
    setUserApiKeyStatus,
    userPages,
  } = useContext(UserContext);
  const [companies, setcompanies] = useState([userData]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleEdit, setIsModalVisibleEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [editName, setEditName] = useState("");
  const [editRole, setEditRole] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("user");
  const [vehicles, setVehicles] = useState([]);
  const [companyVehicles, setcompanyVehicles] = useState([]);
  const [userVehicleAccess, setUserVehicleAccess] = useState({});
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [hasFullAccess, setHasFullAccess] = useState(true);
  const [vehiclesLoading, setVehiclesLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [adminPages, setAdminPages] = useState([]);
  const [activeKey, setActiveKey] = useState(null);

  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [form2] = Form.useForm();

  const handleRoleChange = (value) => {
    setSelectedRole(value);
    form.setFieldsValue({ role: value });
  };

  const pages = [
    { id: 1, value: "dashboard", name: "Dashboard" },
    { id: 2, value: "mileage", name: "Mileage" },
    { id: 3, value: "fuel", name: "Fuel" },
    { id: 4, value: "idle", name: "Idle" },
    { id: 5, value: "fuel_efficiency", name: "Fuel Efficiency" },
    { id: 6, value: "sensor", name: "Sensor" },
    { id: 7, value: "servicing_reminder", name: "Servicing & Reminder" },
    { id: 8, value: "decision_engine", name: "Decision Engine" },
    { id: 9, value: "more_analysis", name: "More Analysis" },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getUsersList();
      setUsers(response.data);
      // Fetch vehicle access for each user
      for (const user of response.data) {
        await fetchUserVehicleAccess(user.id);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  const fetchVehicles = async () => {
    try {
      setVehiclesLoading(true);
      const response = await getCompanyVehicles(userData?.id);
      if (response?.data) {
        setVehicles(response?.data);
      } else {
        setVehicles([]);
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      setVehicles([]);
      message.error("Failed to fetch vehicles");
    } finally {
      setVehiclesLoading(false);
    }
  };

  const fetchUserVehicleAccess = async (userId) => {
    try {
      const response = await getUserVehicleAccess(userId);
      if (response?.data) {
        const formattedData = response.data.map((item) => ({
          ...item,
          key: item.vehicle_name,
          user_id: userId,
        }));
        setUserVehicleAccess((prev) => ({
          ...prev,
          [userId]: formattedData,
        }));
      }
    } catch (error) {
      console.error("Error fetching user vehicle access:", error);
      message.error("Failed to fetch vehicle access");
    }
  };

  const fetchCompanyVehicles = async () => {
    try {
      setVehiclesLoading(true);
      const response = await getCompanyVehicles(userData?.id);
      if (response?.data) {
        setVehicles(response.data);
      } else {
        setVehicles([]);
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      setVehicles([]);
      message.error("Failed to fetch vehicles");
    } finally {
      setVehiclesLoading(false);
    }
  };

  const fetchAdminPages = async () => {
    try {
      const response = await getAdminPages();
      setAdminPages(response?.data?.page_access);
      message.success(response?.data?.message);
    } catch (error) {
      message.error("Failed To Fetch Admin Pages");
    }
  };

  useEffect(() => {
    fetchData();
    if (userData?.id) {
      fetchAdminPages();
      fetchVehicles();
    }
  }, [userData?.id]);

  const handleCreateUser = async (values) => {
    try {
      setLoading(true);
      const response = await createUser(
        values?.username,
        values?.email,
        values?.role,
        // values?.company_name,
        values?.address,
        values?.password,
        values?.parent_company
      );
      if (response.data) {
        const newUser = response.data;
        setUsers((prevUsers) => [...prevUsers, newUser]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      notification.error({
        key: "Error",
        message: "Error",
        description: error?.response?.data?.api_key || "Can't Create User",
        placement: "topRight",
      });
      setLoading(false);
    } finally {
      setIsModalVisible(false);
    }
  };

  const handleEdit = (user) => {
    setEditId(user?.id);
    setEditName(user?.name);
    setEditEmail(user?.email);
    setEditRole(user?.role);
    setIsModalVisibleEdit(true);
  };

  const handleEditUser = async (values) => {
    try {
      const values = await form2.validateFields();
      setLoading(true);
      const response = await editUser(
        editId,
        values?.username,
        values?.email,
        values?.role,
        values?.api_key
      );

      if (response.data) {
        message.success(response?.data?.message);
        fetchData();
        form.resetFields();
      }
    } catch (error) {
      console.error("Error updating user:", error);
      notification.error({
        key: "Error",
        message: "Error",
        description: error?.response?.data?.api_key || "Can't Create User",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
      setIsModalVisibleEdit(false);
    }
  };

  const checkValidation = async () => {
    try {
      const response = await checkApiKeyValidity();
      setUserApiKeyStatus({
        status: response.data.status,
        message: response.data.message,
      });
    } catch (error) {
      message.error("Failed To Check Api Key Status");
    }
  };

  const handleLoginAsUser = async (id) => {
    try {
      setUserApiKeyStatus(null);
      message.success("Signing out from the admin account");
      const response = await loginAsUser(id);
      localStorage.clear();
      message.success("Logging into the user account");
      localStorage.setItem(
        encryptText("token"),
        encryptText(
          JSON.stringify({
            access: response?.data?.access,
            refresh: response?.data?.refresh,
          })
        )
      );
      localStorage.setItem(
        encryptText("user"),
        encryptText(
          JSON.stringify({
            id: response?.data?.id,
            role: response?.data?.role,
            verified: response?.data?.verified,
            name: response?.data?.name,
            email: response?.data?.email,
            profile_picture: response?.data?.profile_picture,
          })
        )
      );
      updateUserStates(setUserData, setUserToken);
      setUserPages(response?.data?.pages);

      if (response?.data?.verified) {
        if (response?.data?.role !== "admin") {
          await checkValidation();
        }
      } else {
        navigate("/verification-link");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  const handleChangeStatus = async (id, action) => {
    try {
      setLoading(true);
      const response = await alterUserStatus(id, action);
      message.success(response?.data?.message);
      setLoading(false);

      if (action === "enable") {
        setUsers((prevUsers) =>
          prevUsers?.map((user) =>
            user.id === id ? { ...user, status: "Active" } : user
          )
        );
      } else {
        setUsers((prevUsers) =>
          prevUsers?.map((user) =>
            user.id === id ? { ...user, status: "Inactive" } : user
          )
        );
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  const checkUserStatus = (status) => {
    if (status === "Active") {
      return true;
    } else {
      return false;
    }
  };

  // const checkPageAccess = (page, pages) => {
  //   return pages?.includes(page);
  // };

  const checkPageAccess = (page, pages) => {
    const inAdminPages = adminPages?.includes(page);
    const inUserPages = pages?.includes(page);

    console.log(inUserPages);

    let value = "restrict";
    let disabled = true;

    if (inAdminPages && inUserPages) {
      value = "view";
      disabled = false;
    } else if (inAdminPages && !inUserPages) {
      console.log("came here");
      value = "restrict";
      disabled = false;
    } else if (!inAdminPages && !inUserPages) {
      value = "restrict";
      disabled = true;
    }

    console.log("Printed Here", value, disabled);
    return { value, disabled };
  };

  const handleChangeAccess = async (id, page, action) => {
    try {
      const response = await pageAccess(id, page, action);
      message.success(response?.data?.message);

      setUsers((prevUsers) => {
        return prevUsers?.map((user) => {
          if (user.id === id) {
            let updatedPages;
            if (action === "view") {
              updatedPages = user?.pages?.includes(page)
                ? user.pages
                : [...user.pages, page];
            } else {
              updatedPages = user.pages.filter((p) => p !== page);
            }
            return { ...user, pages: updatedPages };
          }
          return user;
        });
      });

      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setIsModalVisibleEdit(false);
    setIsModalVisible(false);
    form.resetFields();
    form2.resetFields();
  };

  const handleVehicleModal = (id) => {
    navigate(`/vehicles/${id}`);
  };

  const handleVehicleChange = (values, availableVehicles) => {
    if (values.includes(SELECT_ALL_VALUE)) {
      // Toggle select all / unselect all
      if (selectedVehicles.length === availableVehicles.length) {
        setSelectedVehicles([]);
      } else {
        setSelectedVehicles(availableVehicles.map((v) => v.id));
      }
      return;
    }

    setSelectedVehicles(values);
  };

  const handleGrantAccess = async (userId) => {
    if (!selectedVehicles.length) {
      message.warning("Please select at least one vehicle");
      return;
    }
    try {
      setLoading(true);
      const response = await grantVehicleAccess(
        userId,
        selectedVehicles,
        hasFullAccess
      );
      if (response.data) {
        message.success("Vehicle access granted successfully");
        fetchUserVehicleAccess(userId);
        setSelectedVehicles([]);
      }
    } catch (error) {
      message.error("Failed to grant vehicle access");
    } finally {
      setLoading(false);
    }
  };

  const handleRevokeAccess = async (userId, vehicleId) => {
    try {
      setLoading(true);
      const response = await revokeVehicleAccess(userId, [vehicleId]);
      if (response.data) {
        message.success("Vehicle access revoked successfully");
        await fetchUserVehicleAccess(userId);
      }
    } catch (error) {
      console.error("Error revoking vehicle access:", error);
      message.error("Failed to revoke vehicle access");
    } finally {
      setLoading(false);
    }
  };

  const handleRevokeAllAccess = async (userId) => {
    const userAccess = userVehicleAccess[userId] || [];

    if (!userAccess.length) {
      message.warning("No vehicles to revoke");
      return;
    }

    const vehicleIds = userAccess.map((v) => v.vehicle_id);

    try {
      setLoading(true);
      await revokeVehicleAccess(userId, vehicleIds);
      message.success("All vehicle access revoked successfully");
      await fetchUserVehicleAccess(userId);
    } catch (error) {
      console.error("Error revoking all vehicle access:", error);
      message.error("Failed to revoke all vehicle access");
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteUser = async (user_id) => {
    setLoadingDelete(true);

    try {
      await deleteUser(user_id);

      setUsers((prevUsers) =>
        prevUsers?.filter((user) => user?.id !== user_id)
      );

      message.success("User Deleted Successfully");
    } catch (error) {
      console.error("Error deleting user:", error);
    } finally {
      setLoadingDelete(false);
    }
  };
  const handleViewClick = (userId, key) => {
    if (activeKey === key) {
      setActiveKey(null);
    } else {
      setActiveKey(key);
    }
  };

  const vehicleColumns = [
    {
      title: "Vehicle",
      dataIndex: "vehicle_name",
      key: "vehicle_name",
    },
    {
      title: "Access Type",
      dataIndex: "has_full_access",
      key: "access_type",
      render: (hasFullAccess) => (
        <span style={{ color: hasFullAccess ? "#52c41a" : "#1890ff" }}>
          {hasFullAccess ? "Full Access" : "View Only"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          className="delete-btn"
          danger
          size="small"
          onClick={() => handleRevokeAccess(record.user_id, record.vehicle_id)}
        >
          Revoke Access
        </Button>
      ),
    },
  ];

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="loader-container"
      >
        <ClipLoader size={50} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  return (
    <div className="user-company">
      <div className="page-header">
        <div className="page-title">
          <div className="title">General</div>
          <div className="title-description">
            {new Date().toLocaleDateString("en-US", {
              weekday: "long",
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </div>
        </div>
        <div className="btns-container">
          <Button
            loading={loading}
            onClick={() => {
              setFlag(true);
            }}
            className="login-btn"
          >
            Go to Dashboard
          </Button>

          <Button
            className="create-user-button"
            onClick={() => setIsModalVisible(true)}
          >
            Create new user
          </Button>
        </div>
      </div>
      <Collapse
        bordered={false}
        activeKey={activeKey}
        expandIcon={() => null}
        accordion
        onChange={(key) => setActiveKey(key)}
      >
        {users?.map((user, index) => {
          const assignedVehicleIds = new Set(
            userVehicleAccess[user.id]?.map((access) => access.vehicle_id) || []
          );

          const availableVehicles =
            vehicles?.filter(
              (vehicle) => !assignedVehicleIds.has(vehicle.id)
            ) || [];

          const vehicleSelectOptions = [
            {
              label:
                selectedVehicles.length === availableVehicles.length &&
                  availableVehicles.length > 0
                  ? "Unselect All"
                  : "Select All",
              value: SELECT_ALL_VALUE,
              disabled: availableVehicles.length === 0,
            },
            ...availableVehicles.map((vehicle) => ({
              label: vehicle.vehicle_name,
              value: vehicle.id,
            })),
          ];

          return (
            <>
              <Panel
                header={
                  <>
                    <div
                      onClick={(e) => e.stopPropagation()}
                      className="User-information"
                    >
                      <div className="Info-content">
                        <div className="profile-text">Team</div>

                        <div className="profile-info">
                          <div className="compact-avatar">
                            {user?.profile_picture ? (
                              <img
                                className="profile-pic"
                                src={user?.profile_picture}
                                alt="user-icon"
                              />
                            ) : (
                              <UserOutlined className="profile-pic" />
                            )}
                          </div>

                          <div className="profile-details">
                            <div className="profile-name">{user?.name}</div>
                            <div className="profile-email">{user?.email}</div>
                          </div>
                        </div>
                      </div>
                      <div className="profile-actions">
                        <div className="profile-line">
                          <div
                            onClick={() => {
                              handleEdit(user);
                            }}
                            className="edit-section"
                          >
                            <svg
                              width="1em"
                              height="1em"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.50004 15.1667H14.5834M12.5 6.83333L15 4.33333L11.6667 1L9.16671 3.5M12.5 6.83333L4.16671 15.1667H0.833374V11.8333L9.16671 3.5M12.5 6.83333L9.16671 3.5"
                                stroke="#3B82F6"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            Edit
                          </div>
                          <div className="view-section">
                            <Button
                              icon={
                                activeKey === index.toString() ? (
                                  <CaretUpOutlined />
                                ) : (
                                  <CaretDownOutlined />
                                )
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                handleViewClick(user?.id, index.toString());
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {activeKey === index.toString()
                                  ? "Close"
                                  : "View"}
                              </span>
                            </Button>
                          </div>
                        </div>
                        <div
                          className={`custom-status-btn ${checkUserStatus(user?.status)
                            ? "active"
                            : "inactive"
                            }`}
                        >
                          {checkUserStatus(user?.status)
                            ? "Active"
                            : "Inactive"}
                        </div>
                      </div>
                    </div>
                  </>
                }
                key={index}
                className="panel-style"
              >
                <div className="panel-content">
                  <div className="section-company">
                    <div className="section-text-company">
                      <div className="section-title-company">
                        Log in as user
                      </div>
                      <div className="section-description-company">
                        Login as user to see their POV
                      </div>
                    </div>
                    <Button
                      name="action-button login-btn"
                      loading={loading}
                      onClick={() => {
                        handleLoginAsUser(user?.id);
                      }}
                      className="login-btn"
                    >
                      Login As User
                    </Button>
                  </div>
                  <div className="section-company">
                    <div className="section-text-company">
                      <div className="section-title-company">
                        Account Status
                      </div>
                      <div className="section-description-company">
                        You can enable or disable accounts of the user
                      </div>
                    </div>
                    <div className="button-group">
                      <Button
                        loading={loading}
                        className={`action-button ${checkUserStatus(user?.status)
                          ? "disable-btn enable-selected"
                          : "enable-btn"
                          }`}
                        disabled={checkUserStatus(user?.status)}
                        onClick={() => handleChangeStatus(user?.id, "enable")}
                      >
                        Enable
                      </Button>
                      <Button
                        loading={loading}
                        className={`action-button ${!checkUserStatus(user?.status)
                          ? "disable-btn disable-selected"
                          : "enable-btn"
                          }`}
                        disabled={!checkUserStatus(user?.status)}
                        onClick={() => handleChangeStatus(user?.id, "disable")}
                      >
                        Disable
                      </Button>
                    </div>
                  </div>

                  <div className="section-company page-access">
                    <div
                      className="section-title-company"
                      style={{ marginBottom: "15px" }}
                    >
                      Pages Access
                    </div>
                    {pages?.map((page, index) => {
                      const accessState = checkPageAccess(
                        page?.value,
                        user?.pages
                      );
                      console.log(accessState);
                      return (
                        <div className="section-options">
                          <div className="section-description">
                            {page?.name}
                          </div>
                          <div className="radio-group">
                            <Radio.Group
                              value={accessState.value}
                              onChange={(e) =>
                                handleChangeAccess(
                                  user?.id,
                                  page.value,
                                  e.target.value
                                )
                              }
                              disabled={accessState.disabled}
                            >
                              <Radio value="view">View</Radio>
                              <Radio value="restrict">Restrict</Radio>
                            </Radio.Group>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="section-company vehicle-access-section">
                    <div className="section-text-company">
                      <div className="section-title-company">
                        Vehicle Access Management
                      </div>
                      <div className="section-description-company">
                        Manage which vehicles this user can access
                      </div>
                    </div>
                    <div className="vehicle-access-controls">
                      <Select
                        className="select-vehicle"
                        popupClassName="custom-select-dropdown"
                        mode="multiple"
                        placeholder="Select vehicles"
                        value={selectedVehicles}
                        onChange={(values) =>
                          handleVehicleChange(values, availableVehicles)
                        }
                        style={{ width: "100%", maxWidth: 300 }}
                        loading={vehiclesLoading}
                        options={vehicleSelectOptions}
                      />

                      <Checkbox
                        checked={hasFullAccess}
                        onChange={(e) => setHasFullAccess(e.target.checked)}
                        style={{ marginTop: 8 }}
                      >
                        Grant full access (edit permissions)
                      </Checkbox>
                      <Button
                        className="enable-btn "
                        loading={loading}
                        onClick={() => handleGrantAccess(user.id)}
                        style={{ marginTop: 8, marginLeft: 138 }}
                      >
                        Grant Access
                      </Button>
                    </div>
                    <div
                      className="vehicle-access-list"
                      style={{ marginTop: 16 }}
                    >
                      {userVehicleAccess[user.id]?.length > 0 && (
                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                          <Popconfirm
                            title="Revoke all vehicle access?"
                            description="This will remove access to all vehicles for this user."
                            onConfirm={() => handleRevokeAllAccess(user.id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button danger size="small" className="delete-btn">
                              Revoke All
                            </Button>
                          </Popconfirm>
                        </div>
                      )}

                      {userVehicleAccess[user.id]?.length > 0 ? (
                        <Table
                          columns={vehicleColumns}
                          dataSource={userVehicleAccess[user.id]}
                          rowKey="vehicle_id"
                          pagination={false}
                          loading={loading}
                        />
                      ) : (
                        <div className="no-access">
                          No vehicles have been granted access to this user
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="delete-panel">
                    <div className="section-company section-delete">
                      <div className="section-text-company">
                        <div className="section-title-company">
                          <div> Delete User</div>
                        </div>

                        <div
                          className="section-description-user"
                          style={{ color: "red" }}
                        >
                          This action will remove the user. Continue?
                        </div>
                      </div>
                      <Popconfirm
                        title="Delete the user"
                        description="Are you sure to delete this user?"
                        onConfirm={() => handleDeleteUser(user?.id)}
                        okText="Yes"
                        cancelText="No"
                        placement="left"
                      >
                        <Button
                          icon={<DeleteOutlined />}
                          loading={loadingDelete}
                          style={{ backgroundColor: "transparent" }}
                          className="delete-btn"
                          danger
                        >
                          Delete
                        </Button>
                      </Popconfirm>
                    </div>
                  </div>
                </div>
              </Panel>
            </>
          );
        })}
      </Collapse>

      <Modal
        className="Edit-modal-company"
        title="Create New User"
        open={isModalVisible}
        onOk={() => form.submit()}
        onCancel={handleModalClose}
        confirmLoading={loading}
        okText="Create"
        cancelText="Cancel"
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleCreateUser}
          className="form"
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please input the username!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please input a valid email!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          {/* <Form.Item
            label="Company Name"
            name="company_name"
            rules={[{ required: true, message: "Please input the company name!" }]}
          >
            <Input />
          </Form.Item> */}
          <Form.Item label="Company (optional)" name="parent_company">
            <Select
              popupClassName="custom-select-dropdown"
              suffixIcon={<CaretDownOutlined />}
              placeholder={
                selectedRole === "company"
                  ? "Parent company not needed for Company role"
                  : "Select a parent company (optional)"
              }
              disabled={selectedRole === "company"}
              allowClear
              defaultValue={selectedRole !== "company" && companies?.[0]?.id}
            >
              {companies?.map((company) => (
                <Option key={company.id} value={company.id}>
                  {company.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Address"
            name="address"
            rules={[
              { required: true, message: "Please input the company address!" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Role"
            name="role"
            rules={[{ required: true, message: "Please select the role!" }]}
          >
            <Select
              placeholder="Select a role"
              popupClassName="custom-select-dropdown"
              onChange={handleRoleChange}
              value={selectedRole}
              suffixIcon={<CaretDownOutlined />}
            >
              <Option value="user">User</Option>
            </Select>
          </Form.Item>

          {/* <Form.Item
            label="API Key"
            name="api_key"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item> */}
          <div className="password-field">
            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please input the password!" },
                { min: 6, message: "Password must be at least 6 characters!" },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </div>
        </Form>
      </Modal>

      <Modal
        className="Edit-modal-company"
        form={form2}
        title="Edit User"
        visible={isModalVisibleEdit}
        onCancel={() => handleModalClose()}
        onOk={() => form2.submit()}
        confirmLoading={loading}
        okText="Save Changes"
        cancelText="Cancel"
      >
        <Form
          initialValues={{
            username: editName,
            email: editEmail,
            role: editRole,
          }}
          layout="vertical"
          onFinish={handleEditUser}
          className="form"
          form={form2}
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please input the username!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please input a valid email!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Role"
            name="role"
            rules={[{ required: true, message: "Please select the role!" }]}
          >
            <Select
              suffixIcon={<CaretDownOutlined />}
              popupClassName="custom-select-dropdown"
              placeholder="Select a role"
            >
              <Option value="admin">Admin</Option>
              <Option value="user">User</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="API Key"
            name="api_key"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Users;
